import { useParams } from 'react-router';

import { cleanFormIdParam, ID_PARAMS } from 'common/src/routes/BaseRoutes';
import { IUser } from 'common/src/types/interfaces';

import UserForm from 'portal/src/components/systemAdministration/Form/User/UserForm';
import { FormComponentType } from 'portal/src/layouts/base/FormComponentType';

const SystemAdministrationOrgUserForm: FormComponentType = ({
  entity,
  handleBackAction,
}: {
  entity?: IUser;
  handleBackAction: () => void;
}) => {
  const orgId = useParams()[cleanFormIdParam(ID_PARAMS.ORG)];

  return (
    <UserForm
      entity={entity}
      handleBackAction={handleBackAction}
      organizationId={orgId}
    />
  );
};

export default SystemAdministrationOrgUserForm;
